module.exports = __webpack_public_path__ + "img/czylogo.fe76e713.png";